// 3rd Party Modules/Services
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';

// CPUI Modules/Services
import {
  AssetService,
  AssetStateService,
  ContentService,
  ContentStateService,
  KeyboardService,
  MMMockHttpInterceptor,
  MOCK_INTERCEPTOR_INTERCEPTS,
  MOCK_INTERCEPTOR_RESOURCE_SERVER,
  StorageService
} from './services/index';


import {AppRoutes} from './app.routing';
import {AppComponent} from './app.component';
import {environment} from '../environments/environment';

const providers = <any>[AssetService, AssetStateService, ContentService, ContentStateService, KeyboardService, StorageService];

import * as mockIntercepts from '../mock-intercept.conf.json';

if (environment.mock) {
  providers.push({provide: MOCK_INTERCEPTOR_INTERCEPTS, useValue: mockIntercepts},
    {provide: MOCK_INTERCEPTOR_RESOURCE_SERVER, useValue: environment.resourceServer},
    {provide: HTTP_INTERCEPTORS, useClass: MMMockHttpInterceptor, multi: true});
}

import {ContentDetailsPillsComponent} from './components/content-details-pills/content-details-pills.component';
import {LogoNavComponent} from './components/logo-nav/logo-nav.component';
import {AntennaComponent} from './components/antenna/antenna.component';
import {HomeComponent} from './components/views/home/home.component';
import {ImageInspireComponent} from './components/image-inspire/image-inspire.component';
import {SubNavComponent} from './components/sub-nav/sub-nav.component';
import {ConsultingComponent} from './components/views/consulting/consulting.component';
import {AboutComponent} from './components/views/about/about.component';
import {ContactComponent} from './components/views/contact/contact.component';
import {CareersComponent} from './components/views/careers/careers.component';
import {MessageContentDetailComponent} from './components/message-content-detail/message-content-detail.component';
import {AnimatedCloudsComponent} from './components/animated-clouds/animated-clouds.component';
import {SafePipe} from './pipes/safe.pipe';

@NgModule({
  declarations: [
    AppComponent,
    ContentDetailsPillsComponent,
    LogoNavComponent,
    AntennaComponent,
    HomeComponent,
    ImageInspireComponent,
    SubNavComponent,
    ConsultingComponent,
    AboutComponent,
    ContactComponent,
    CareersComponent,
    MessageContentDetailComponent,
    AnimatedCloudsComponent,
    SafePipe
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutes,
    CommonModule,
    FormsModule,
    HttpClientModule
  ],
  providers,
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts